<template>
  <div class="index">
    <img
      class="index-title"
      src="https://cbgccdn.thecover.cn/@/images/20210525/1621936383794024427.png"
      alt=""
    />
    <div class="main-ctrls">
      <button class="btn" @click="onBtnClick">{{ userStatus.tip }}</button>
      <button class="btn" @click="$router.push('/rank')">排行榜</button>
      <button
        class="btn"
        @click="showRecords = true"
        v-if="userStatus.status > 1 && userStatus.status < 4"
      >
        打卡查询
      </button>
      <button class="btn" @click="showRules = true">活动规则</button>
    </div>

    <div class="organizitions">
      主办单位：<br />四川省委依法治省办 四川省直机关工委 四川省司法厅<br />
      承办单位：<br />四川日报全媒体
    </div>
    <transition name="modal">
      <page v-if="showRecords" :isModal="true" v-on:back="showRecords = false">
        <records
          :records="clockinList"
          :max_recent_cont="max_recent_cont"
          :max_cont="max_cont"
        ></records>
      </page>
    </transition>

    <transition name="modal">
      <page v-if="showRules" :isModal="true" v-on:back="showRules = false">
        <div class="rule-wrap">
          <p class="rule-title">活动规则</p>
          <p>
            1、本活动由四川省委依法治省办、省直机关工委、省司法厅主办，四川日报川观新闻客户端承办。
          </p>
          <p>2、活动时间：2021年6月1日-7月1日。</p>
          <p>
            3、活动期间，用户每日有一次答题机会；每次回答5道题，答对1题得1分，答错不得分；中途退出答题的用户，得分为0分。
          </p>
          <p>4、答题只能在川观新闻客户端中进行，请保持登录状态。</p>
          <p>5、用户答题前需选择所在市州和所在单位，为市州和单位助力。</p>
          <p>
            6、单位分数榜和市州分数榜，是根据该组织内的参与者每局分数计算所得，参与人数越多、答题胜率越高，则组织平均分和排名越高。
          </p>
          <p>
            7、用户攒够答题天数，将自动解锁徽章，并为甘孜州新龙县、白玉县相关小学和幼教点孩子捐赠公益物资。规则如下：
          </p>
          <p>连续打卡7天，将为山区孩子送上一支定制笔；</p>
          <p>连续打卡14天，将为山区孩子送上一本精选好书；</p>
          <p>连续打卡21天，将为山区孩子送上一个定制书包；</p>
          <p>连续打卡30天，将为山区孩子送上一件防寒羽绒服。</p>
          <p>8、本次活动最终解释权归川观新闻所有。</p>
        </div>
      </page>
    </transition>

    <transition name="modal">
      <div class="poster-bg" v-if="showPoster">
        <img :src="posterUrl" alt="" />
        <div>长按保存分享</div>
        <button @click="showPoster = false"></button>
      </div>
    </transition>
  </div>
</template>

<script>
import page from "../../components/page";
import records from "./records";
import { Button, Cascader, Field, Popup, Toast } from "vant";
import {
  USER_STATUS,
  DAY_IN_SECONED,
  DURATION,
  START_DATE,
  POSTERS,
} from "./config";
import { login, getClockinList } from "../../apis/index";
import { cbgcAnalyze } from "../../utils/index";
import VConsole from "vconsole";
export default {
  components: { page, Button, Field, Cascader, Popup, records },
  data() {
    return {
      showRecords: false,
      showRules: false,
      userStatus: USER_STATUS[0],
      startDate: START_DATE,
      isClockined: false,
      clockinList: [],
      max_cont: 0,
      max_recent_cont: 0,

      showPoster: false,
      posterUrl: POSTERS[0],
    };
  },
  created() {
    if (this.$route.query.debug) {
      new VConsole();
    }
    // this.getRecords();
    if (COVERAPP.Attribute.isApp() && COVERAPP.Attribute.isAndroid()) {
      var an_timer = setInterval(() => {
        if (window.AndroidBridging) {
          clearInterval(an_timer);
          this.preCheck();
        }
      }, 50);
    } else {
      this.preCheck();
    }

    cbgcAnalyze({
      activeId: "sftdtdk",
      activeName: "党建引领法治答题打卡活动",
    });
  },
  methods: {
    getRecords() {
      let toast = Toast({
        type: "loading",
        duration: 0,
      });
      getClockinList().then((resp) => {
        toast.clear();
        this.isClockined = [].concat(resp.data.list);
        this.clockinList = resp.data.list;
        this.max_cont = resp.data.max_cont;
        this.max_recent_cont = resp.data.max_recent_cont;
        if (resp.data.clock_in) {
          if (this.userStatus.status !== 6 && this.userStatus.status !== 5) {
            this.userStatus = USER_STATUS[3];
          }
        }
        switch (this.max_cont) {
          case 1:
            {
              this.posterUrl = POSTERS[0];
              this.$nextTick(() => {
                this.showPoster = true;
              });
            }
            break;
          case 7:
            {
              this.posterUrl = POSTERS[1];
              this.$nextTick(() => {
                this.showPoster = true;
              });
            }
            break;
          case 14:
            {
              this.posterUrl = POSTERS[2];
              this.$nextTick(() => {
                this.showPoster = true;
              });
            }
            break;
          case 21:
            {
              this.posterUrl = POSTERS[3];
              this.$nextTick(() => {
                this.showPoster = true;
              });
            }
            break;
          case 30: {
            this.posterUrl = POSTERS[4];
            this.$nextTick(() => {
              this.showPoster = true;
            });
          }
          default: {}
        }
      });
    },
    onBridgeSuccess(resp, isBind) {
      let _this = this;
      let info = typeof resp === "string" ? JSON.parse(resp) : resp;
      if (info && info.user_id) {
        // 有user_ID 已登录
        console.log("already login");
        console.log(info);
        if (info.mobile) {
          console.log("有手机号");
          _this.userInfo = info;
          login(info).then(() => {
            if (
              _this.userStatus.status !== 6 &&
              _this.userStatus.status !== 5
            ) {
              _this.userStatus = USER_STATUS[2];
            }
            _this.getRecords();
          });
        } else {
          console.log("无手机号");
          // 无手机号 设置为绑定手机
          _this.userStatus = USER_STATUS[1];
        }
      } else {
        if (!isBind) {
          _this.userStatus = USER_STATUS[0];
        }
      }
    },
    onBtnClick() {
      let _this = this;
      if (this.userStatus.status === 0) {
        COVERAPP.Method.OpenLogin({
          callback: function (resp) {
            _this.onBridgeSuccess(resp);
          },
        });
      } else if (this.userStatus.status === 1) {
        COVERAPP.Method.bindMobile({
          callback: function (resp) {
            _this.onBridgeSuccess(resp, true);
          },
        });
      } else if (this.userStatus.status === 2) {
        this.$router.push("/qa");
      } else if (this.userStatus.status === 4) {
        // goAppLink("https://cbgc.scol.com.cn/news/1427519");
        // https://cbgc.scol.com.cn/news/1427519
      }
    },
    preCheck() {
      if (COVERAPP.Attribute.isApp()) {
        let now = new Date();
        let _this = this;
        if (now < this.startDate.getTime()) {
          this.userStatus = USER_STATUS[5];
        } else if (now > this.startDate.getTime() + DURATION * DAY_IN_SECONED) {
          this.userStatus = USER_STATUS[6];
        }
        COVERAPP.Method.GetUser({
          callback: function (resp) {
            _this.onBridgeSuccess(resp);
          },
        });
      } else {
        this.userStatus = USER_STATUS[4];
        // location.replace("https://cbgc.scol.com.cn/news/1427519");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.poster-bg {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 60%;
    border-radius: 5px;
    margin-bottom: 5px;
  }

  div {
    color: rgb(184, 182, 182);
    margin-bottom: 10px;
    font-size: 10px;
  }

  button {
    border: none;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    color: #fff;
    //   background-color: #1e7a87;
    background-color: #ebd275;
    background-image: url("https://cbgccdn.thecover.cn/@/images/20210528/1622187450857017362.png");
    background-size: 50% 50%;
    background-repeat: no-repeat;
    background-position: center center;
    box-shadow: 0 2px 1px 1px #9c8943;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.organizitions {
  // margin-top: 50px;
  color: #fff;
  font-size: 12px;
  position: absolute;
  bottom: 20px;
  width: 100%;
  text-align: center;
}
.index {
  width: 100%;
  height: 100%;
  background-image: url("https://cbgccdn.thecover.cn/@/images/20210525/1621936302957004408.jpg");
  background-size: 100% 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-top: 100px;
  .index-title {
    width: 80%;
  }
}
.main-ctrls {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 50px;
  .btn {
    flex: 0 0 auto;
    margin-bottom: 20px;
  }
}

.rule-wrap {
  border-radius: 5px;
  background-color: #fff;
  padding: 15px;
  text-align: left;
  .rule-title {
    text-align: center;
    padding: 10px;
    font-size: 20px;
    font-weight: bold;
  }
  p {
    margin: 0;
    margin-bottom: 10px;
    span {
      font-weight: bold;
    }
  }
}
</style>